<template>
	<section>
		<table class="table table-sm">
			<thead>
				<th>ID</th>
				<th>Início</th>
				<th>Fim</th>
				<th>Origem</th>
				<th>Destino</th>
				<th>Tempo</th>
				<th>Tarifa</th>
			</thead>

			<tbody>
				<tr>
					
				</tr>
			</tbody>
		</table>
	</section>
</template>

<script>
	export default {
		name: 'Detalhamento',

		data() { return { type: null }},
	};
</script>

<style>
</style>